import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "src/features/fields/components/Tooltip";
import { switchString } from "src/utils/utils";
import receipt from "src/features/fields/assets/receipt.svg";
import pdf from "src/features/fields/assets/pdf.svg";
import download from "src/features/fields/assets/download.svg";
import check from "src/features/fields/assets/check.svg";
import { Button, Modal } from "src/components";
import { useState } from "react";
import EditStockistName from "./OrderInfoTabCards/EditStockist";
import CashDiscountChange from "./OrderInfoTabCards/CashDiscountChange";
import ChangeOrderType from "./OrderInfoTabCards/ChangeOrderType";
import { downloadInvoice } from "src/services/invoice-api";
import { RootState } from "src/context/store";
import { useToast } from "src/hooks/useToast";
import { useSelector } from "react-redux";
interface OrderInfoHomeScreenInterface {
  orderInfo: any;
  fetchOrderDetails: () => void;
}

export const OrderInfoHomeScreen = ({ orderInfo, fetchOrderDetails }: OrderInfoHomeScreenInterface) => {
  const [editingStockistName, setEditingStockistName] = useState(false);
  const [editingCashDiscount, setEditingCashDiscount] = useState(false);
  const [editingOrderType, setEditingOrderType] = useState(false);
  const { orderDetailsFiltered } = useSelector((state: RootState) => state.ord);
  const { toast } = useToast();
  // navigator.geolocation.getCurrentPosition(
  //   (position) => {
  //     console.log("Latitude:", position.coords.latitude);
  //     console.log("Longitude:", position.coords.longitude);
  //   },
  //   (error) => {
  //     console.error("Error getting location:", error);
  //   }
  // );

  const openGoogleMaps = (latitude: number, longitude: number) => {
    const url = `https://www.google.com/maps?q=${latitude},${longitude}`;
    window.open(url, "_blank");
  };

  return (
    <div className="p-6 mt-10 border border-gray-300 rounded-xl">
      <h1 className="text-[#49484C] border-b-2 border-gray-200 pb-5 font-semibold text-[1.5rem]">
        <img src={receipt} alt="receipt" className="inline mr-2 w-6 h-6" />
        Order Info
      </h1>
      <p className="text-[#49484C] font-semibold mt-8 text-lg">Summary</p>
      <div>
        <div className={"grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 w-[100%] py-5 xl:grid-cols-3 gap-y-5 mb-5"}>
          {Object.entries(orderInfo)?.map(
            ([key, value]) =>
              typeof value === "string" &&
              value !== "" && (
                <div key={key?.toString()} className={"grid grid-cols-2 text-sm xl:grid-cols-2"}>
                  <p className="text-gray-500 place-self-center text-[1rem] mr-auto whitespace-break-spaces leading-[0.02rem] not-italic">
                    {switchString(key)} :
                  </p>
                  <div className="mr-auto">
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger>
                          <p className="text-[#1B1A1F] text-[1rem] flex items-center gap-2 text-left mr-auto">
                            {typeof value === "string" && key !== "Location" ? (value?.length > 20 ? value.slice(0, 20) + "..." : value) : ""}
                            {(key === "Counter name" || key === "Counter location" || key === "Clinic name") && (
                              <img src={check} alt="check" className="w-6 h-6" />
                            )}{" "}
                            {key === "Location" && (
                              <Button
                                className="border border-gray-300 rounded-lg px-2 py-1"
                                onClick={() => openGoogleMaps(Number(value?.split(",")[0]), Number(value?.split(",")[1]))}
                              >
                                Open Map
                              </Button>
                            )}
                            {key === "Stockist name" && (
                              <Button className="border border-gray-300 rounded-lg px-2 py-1" onClick={() => setEditingStockistName(true)}>
                                Edit
                              </Button>
                            )}
                            {key === "Cash Discount %" && (
                              <Button className="border border-gray-300 rounded-lg px-2 py-1" onClick={() => setEditingCashDiscount(true)}>
                                Edit
                              </Button>
                            )}
                            {key === "Order Type" && (
                              <Button className="border border-gray-300 rounded-lg px-2 py-1" onClick={() => setEditingOrderType(true)}>
                                Edit
                              </Button>
                            )}
                          </p>
                        </TooltipTrigger>
                        <TooltipContent>{typeof value === "string" ? value : ""}</TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                  </div>
                </div>
              )
          )}
        </div>
      </div>
      <p className="text-[#49484C] font-semibold mt-8 text-lg">Attachments</p>
      <p className="text-[#49484C] mt-6 font-normal text-[1rem] relative pr-4 after:content-[''] after:absolute after:w-[calc(100%-8rem)] after:h-[1px] after:bg-gray-300 after:top-1/2 after:right-0">
        Counter Name
      </p>
      <div className="flex gap-5 mt-2">
        <div className="w-80 h-16 rounded-lg border border-[#E4E4E6] flex items-center justify-between px-2">
          <div className="flex gap-2">
            <img src={pdf} alt="pdf" className="w-10 h-10" />
            <div className="flex flex-col justify-center">
              <p className="text-[#324054] font-normal text-[.9rem]">Counter Attachment</p>
              {/* <p className="text-[#71839B] font-normal text-[.8rem]">313 KB. 31 Aug, 2022</p> */}
            </div>
          </div>
          <Button
            onClick={() => {
              if (!orderDetailsFiltered?.[0]?.counter_copy_path.trim()) {
                toast({ description: "Counter attachment not found", variant: "destructive" });
                return;
              }

              toast({ title: "Downloading...", description: "Downloading counter attachment", variant: "default" });

              downloadInvoice(orderDetailsFiltered?.[0]?.counter_copy_path.trim()).then((res: any) => {
                if (res?.data?.success && res?.data?.data) {
                  window.open(res?.data?.data, "_blank"); // Opens the link in a new tab
                } else {
                  console.error("Failed to download the invoice.");
                }
              });
            }}
          >
            <img src={download} alt="download" className="w-6 h-6 text-gray-500 cursor-pointer" />
          </Button>
        </div>
        <div className="w-80 h-16 rounded-lg border border-[#E4E4E6] flex items-center justify-between px-2">
          <div className="flex gap-2">
            <img src={pdf} alt="pdf" className="w-10 h-10" />
            <div className="flex flex-col justify-center">
              <p className="text-[#324054] font-normal text-[.9rem]">Stockist Attachment</p>
              {/* <p className="text-[#71839B] font-normal text-[.8rem]">313 KB. 31 Aug, 2022</p> */}
            </div>
          </div>
          <Button
            onClick={() => {
              if (!orderDetailsFiltered?.[0]?.stockist_copy_path.trim()) {
                toast({ description: "Stockist attachment not found", variant: "destructive" });
                return;
              }

              toast({ title: "Downloading...", description: "Downloading stockist attachment", variant: "default" });

              downloadInvoice(orderDetailsFiltered?.[0]?.stockist_copy_path.trim()).then((res: any) => {
                if (res?.data?.success && res?.data?.data) {
                  window.open(res?.data?.data, "_blank"); // Opens the link in a new tab
                } else {
                  console.error("Failed to download the invoice.");
                }
              });
            }}
          >
            <img src={download} alt="download" className="w-6 h-6 text-gray-500 cursor-pointer" />
          </Button>
        </div>
      </div>

      <Modal isOpen={editingStockistName} isHeader={false} onCloseModal={() => setEditingStockistName(false)}>
        <EditStockistName onCloseModal={() => setEditingStockistName(false)} />
      </Modal>
      <Modal isOpen={editingCashDiscount} isHeader={false} onCloseModal={() => setEditingCashDiscount(false)}>
        <CashDiscountChange onCloseModal={() => setEditingCashDiscount(false)} />
      </Modal>
      <Modal isOpen={editingOrderType} isHeader={false} onCloseModal={() => setEditingOrderType(false)}>
        <ChangeOrderType onSuccess={fetchOrderDetails} onCloseModal={() => setEditingOrderType(false)} />
      </Modal>
    </div>
  );
};
